import { getLocation } from './nuxtAdapter';

export type Area = 'cn' | 'us'; // 区域

export const PURE_HOST = [
  /jmjuntu.com/,
  /mfai.lzdxedu.com/,
  /3dvirtualhuman.com/,
  /test-youyan30-public.xmov.ai/,
  /test-public.youyan3d.com/,
  /mfai-test.lzdxedu.com/,
];

// 判断是否为纯净版
export const isPureHost = (host?: string): boolean => {
  // return true;
  // @ts-ignore
  const requestUrl = getLocation().host;
  return PURE_HOST.some(item => item.test(host || requestUrl));
};

// 获取当前区域
export const getArea = (): Area => {
  const area = import.meta.env.AREA as string;
  // 处理环境变量中的大写值，转换为小写
  return (area?.toLowerCase() as Area) || 'cn';
};

// 获取版本号
export const getVersion = (): string => {
  return import.meta.env.VERSION || '1.0.0';
};

// 判断是否为国内版
export const isCN = (): boolean => {
  return getArea() === 'cn';
};

// 判断是否为海外版
export const isUS = (): boolean => {
  return getArea() === 'us';
};

// 获取全局配置
export const getGlobalConfig = () => {
  return {
    area: getArea(),
    version: getVersion(),
    isCN: isCN(),
    isUS: isUS(),
  };
};

// 根据区域获取不同的配置
export const getAreaConfig = () => {
  const area = getArea();

  // @ts-ignore
  const requestUrl = getLocation().origin;

  const configs: Record<
    string,
    {
      apiBaseUrl: string;
      cdnBaseUrl: string;
      defaultLocale: 'zh-CN' | 'en-US';
      timezone: string;
      wsMessageCenter: string;
      apiMessageCenter: string;
      feOss: string;
      beOss: string;
      domain: string;
      workspaceDomain: string;
      env: string;
    }
  > = {
    cn: {
      apiBaseUrl: import.meta.env.API_BASE || '',
      cdnBaseUrl: import.meta.env.CDN_BASE_URL || import.meta.env.FE_OSS || '',
      defaultLocale: 'zh-CN',
      timezone: 'Asia/Shanghai',
      wsMessageCenter: import.meta.env.WS_MESSAGE_CENTER || '',
      apiMessageCenter: import.meta.env.API_MESSAGE_CENTER || '',
      feOss: import.meta.env.FE_OSS || '',
      beOss: import.meta.env.BE_OSS || '',
      domain: (isPureHost() ? requestUrl : import.meta.env.API_DOMAIN) || '/',
      workspaceDomain: import.meta.env.WORKSPACE_DOMAIN || '',
      env: import.meta.env.ENV || '',
    },
    us: {
      apiBaseUrl: import.meta.env.API_BASE || '',
      cdnBaseUrl: import.meta.env.CDN_BASE_URL || import.meta.env.FE_OSS || '',
      defaultLocale: 'en-US',
      timezone: 'America/New_York',
      wsMessageCenter: import.meta.env.WS_MESSAGE_CENTER || '',
      apiMessageCenter: import.meta.env.API_MESSAGE_CENTER || '',
      feOss: import.meta.env.FE_OSS || '',
      beOss: import.meta.env.BE_OSS || '',
      domain: import.meta.env.API_DOMAIN || '',
      workspaceDomain: import.meta.env.WORKSPACE_DOMAIN || '',
      env: import.meta.env.ENV || '',
    },
  };

  return configs[area] || configs.cn;
};

// 设置全局配置
export const setupGlobalConfig = () => {
  const config = getGlobalConfig();
  (window as any).__GLOBAL_CONFIG__ = config;
};

// 任务中心 channel
export const YY_COMMON_GENERATE_LIST = 'yy_common_generate_list';
